// extracted by mini-css-extract-plugin
module.exports = {"fading-balls":"FadingBalls_fading-balls__2XawO","fade":"FadingBalls_fade__1V5zP"};